import React from 'react';
import { 
  TrendingUp, 
  Settings, 
  Shield,
  Target
} from 'lucide-react';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';

export const AdditionalSystemKPIs: React.FC<{ data: any }> = ({ data }) => {
  const kpiData = {
    totalAssetsInSystem: {
      value: data?.overview?.totalAssets?.value || 0,
    },
    inspectionCompliance: {
      value: data?.overview?.inspectionCompliance?.value || 0,
    },
    overallRiskScore: {
      value: data?.overview?.overallRiskScore?.value || 0,
    },
    serviceLevelAchievement: {
      value: data?.overview?.serviceLevelAchievement?.value || 0,
    }
  };

  const formatVarianceSummary = (variance: number, period: string) => {
    const sign = variance > 0 ? '+' : '';
    return `${period}: ${sign}${variance}%`;
  };

  const statsData = [
    {
      title: "Total Assets in System",
      count: kpiData.totalAssetsInSystem.value || 0,
      icon: <Settings className="h-8 w-8 text-gray-500" />,
      tooltip: "The total number of individual assets (e.g., pumps, valves, filters) that make up this system."
    },
    {
      title: "Inspection Compliance",
      count: `${kpiData.inspectionCompliance.value || 0}%`,
      icon: <TrendingUp className="h-8 w-8 text-green-500" />,
      tooltip: "The percentage of scheduled inspections for this system that were completed on time in the current period."
    },
    {
      title: "Overall Risk Score",
      count: kpiData.overallRiskScore.value || 0,
      icon: <Shield className="h-8 w-8 text-yellow-500" />,
      tooltip: "The overall risk associated with this system, considering its criticality, redundancy, and potential impact of failure."
    },
    {
      title: "Service Level Achievement",
      count: `${kpiData.serviceLevelAchievement.value || 0}%`,
      icon: <Target className="h-8 w-8 text-green-500" />,
      tooltip: "The percentage of time this system operated within its defined service level agreement targets."
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};